import controller from './auth.controller';
import template from './auth.pug';

const LoginComponent = {
  template,
  controller,
};

export default LoginComponent;



// WEBPACK FOOTER //
// ./client/app/oauth/auth/auth.component.js